<div class="analyst-container">
  @if (isProcessing) {
    <app-nada-spinner [size]="100" />\
  } @else if (!analystInfo) {
    <p class="no-info">
      No Analyst has been assigned to this group. Please check back later.
    </p>
  } @else {
    <div class="profile">
      <img
        src="/assets/images/user-profile.svg"
        alt="Analyst Profile Image"
        class="profile-image"
      />
      <div class="profile-info">
        <h2 class="analyst-name">{{ analystInfo.name }}</h2>
        <p class="analyst-title">{{ analystInfo.title }}</p>
        <p class="analyst-contact">
          Email: <a href="mailto:analyst@email.com">{{ analystInfo.email }}</a>
        </p>
        <p class="analyst-contact">
          Phone:
          <a href="tel:(123) 456-7890">{{ analystInfo.businessPhone }}</a>
        </p>
      </div>
    </div>
  }
</div>
